import { useEffect, useState } from 'react';
import axios from 'axios';

interface StoicQuote {
  text: string;
  author: string;
}

const QUOTE_STORAGE_KEY = 'stoic_quote';
const TIMESTAMP_STORAGE_KEY = 'stoic_quote_timestamp';
const REFRESH_INTERVAL = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

const useStoicQuote = () => {
  const [quote, setQuote] = useState<StoicQuote | null>(null);

  const fetchAndStoreQuote = async () => {
    try {
      const response = await axios.get('https://stoic-quotes.com/api/quote');
      const newQuote = response.data;

      // Store the quote and the current timestamp
      localStorage.setItem(QUOTE_STORAGE_KEY, JSON.stringify(newQuote));
      localStorage.setItem(TIMESTAMP_STORAGE_KEY, Date.now().toString());

      setQuote(newQuote);
    } catch (error) {
      console.error('Error fetching the stoic quote:', error);
    }
  };

  const loadQuote = () => {
    const storedQuote = localStorage.getItem(QUOTE_STORAGE_KEY);
    const storedTimestamp = localStorage.getItem(TIMESTAMP_STORAGE_KEY);

    if (storedQuote && storedTimestamp) {
      const timestamp = parseInt(storedTimestamp, 10);
      const now = Date.now();

      // Check if 12 hours have passed since the last fetch
      if (now - timestamp < REFRESH_INTERVAL) {
        setQuote(JSON.parse(storedQuote));
        return;
      }
    }

    // Fetch a new quote if no valid stored quote exists
    fetchAndStoreQuote();
  };

  useEffect(() => {
    loadQuote();
  }, []);

  return { quote };
};

export default useStoicQuote;
